import BaseApi from "./baseApi";
import type { IdLike } from "../types";

class TalksApi extends BaseApi {
  async addTalk(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
      {
        url: "/talks/addtalk",
        data: data,
        method: "post"
      }
    )
  }
  async getAllTalkList(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
        {
            url:"/talks/getalltalklist",
            method: "get"
        }
    )
}

async getAllTalkSearch(data: Record<string, unknown> | object): Promise<any> {
  return await this.API(
      {
          url:"/talks/getAllTalkSearch",
          method: "get"
      }
  )
}

async getTalk(data: Record<string, unknown> | object, talk_id: IdLike): Promise<any> {
  return await this.API(
      {
          url:`/talks/gettalk/${talk_id}`,
          method: "get"
      }
  )
}
async deleteTalk(data: Record<string, unknown> | object, talk_id: IdLike): Promise<any> {
  return await this.API({
    url: `/talks/deletetalk/${talk_id}`,
    data: data,
    method: 'delete'
  })
}
async searchTalk (data: Record<string, unknown> | object, key: string): Promise<any> {
  return await this.API(
      {
          url:`/talks/searchtalk/${key}`,
          method: "get"
      }
  )
}
async updateTalk(data: Record<string, unknown> | object, talk_id: IdLike): Promise<any> {
  return await this.API({
    url: `/talks/updatetalk/${talk_id}`,
    data: data,
    method: 'put'
  })
}

}

export default TalksApi;
